import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import { CompletedRequirements, get_confirmed_delivered_photo } from "../api/Users";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import i18next from "i18next";
import axios from "../api/constant";

const CompleteRequirement = ({ role, mainId, userData }) => {
  const { t } = useTranslation();
  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [amenityPhotoData, setAmenityPhotoData] = useState([]);


  const fetchCompletedRequirements = async () => {
    try {

      const amenityPhotoData = await get_confirmed_delivered_photo(userData.data.UDISE_code);
      if (amenityPhotoData.status == "success") {
        setAmenityPhotoData(amenityPhotoData.data.asset_images);
        setIsLoading(false);
      } else {
        setAmenityPhotoData([])
        setIsLoading(false);
      }

      const data = await CompletedRequirements(userData.data.school_id, userData.data.UDISE_code);
      if (data.status == "success") {
        setRows(data.data.result);
        setFilteredData(data.data.result);
        setIsLoading(false);
      } else {
        setFilteredData([]);
        setRows([]);
        setIsLoading(false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handleImageClick = (imageData) => {
    var w = window.open('about:blank');
    setTimeout(() => {
      w.document.body.appendChild(w.document.createElement('iframe')).src = "data:image/png;base64," + imageData;
      w.document.body.style.margin = 0;
      w.document.getElementsByTagName("iframe")[0].style.width = '100%';
      w.document.getElementsByTagName("iframe")[0].style.height = '100%';
      w.document.getElementsByTagName("iframe")[0].style.border = 0;
    }, 0);
  };

  useEffect(() => {
    fetchCompletedRequirements();
  }, []);


  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    const filtered = rows.filter(
      (item) =>
        item.requirement_name.toLowerCase().includes(query.toLowerCase()) ||
        item.description.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filtered);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="my-4 col-12 d-flex justify-content-between align-items-center">
            <h5 className="">{t("Completed Requirements")}</h5>
            <TextField
              label={t("Search")}
              variant="outlined"
              value={searchQuery}
              onChange={handleSearchChange}
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
            />
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{t("Sr. No.")}</TableCell>
                  <TableCell align="left">{t("Requirement")}</TableCell>
                  <TableCell align="left">{t("School Name")}</TableCell>
                  <TableCell align="left">{t("Tentative Quantity")}</TableCell>
                  <TableCell align="left">{t("Modified Quantity")}</TableCell>
                  <TableCell align="left">{t("Actual Quantity")}</TableCell>
                  <TableCell align="left">{t("Delivery Date")}</TableCell>
                  <TableCell align="left">{t("Amenity Photo")}</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {index + 1 + page * rowsPerPage}
                        </TableCell>
                        <TableCell align="left">
                          {row.requirement_name}
                        </TableCell>
                        <TableCell align="left">{row.school_name}</TableCell>
                        <TableCell align="left">{row.tentative_amount}</TableCell>
                        <TableCell align="left">{row.quantity}</TableCell>
                        <TableCell align="left">{row.quantity}</TableCell>
                        <TableCell align="left">{row.completed_date}</TableCell>
                        <TableCell align="left">
                          {amenityPhotoData[index] && <img src={`data:image/png;base64,${amenityPhotoData[index].image}`} className="border border-3" alt="Checklist" style={{ width: "50px", borderRadius: "50%", height: "50px" }} onClick={() => handleImageClick(amenityPhotoData[index].image)} />}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={5}>
                    <h4>
                      <i>{t("No data available")}</i>
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={(filteredData || []).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default CompleteRequirement;
